import { inject, injectable } from 'inversify';
// import {
//   InjectionSymbols as LoggerInjectionSymbols,
//   Logger,
// } from '@hitiq/logger';
import { InjectionSymbols, type Logger } from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { ReduxRepository } from '../reduxRepository';
import { Incident, IncidentBackend } from './incident.interface';
import { IncidentTranslator } from './incident.translator';
import { defaultDispatchers, defaultSelectors } from './incident.slice';
import { createIncidentThunk } from './incidentCreate.thunk';
import { updateIncidentThunk } from './incidentUpdate.thunk';
import { deleteIncidentThunk } from './incidentDelete.thunk';
import { loadIncidentThunk } from './incidentLoad.thunk';

@injectable()
export class IncidentRepository extends ReduxRepository<
  Incident,
  IncidentBackend
> {
  constructor(
    @inject(InjectionSymbols.LOGGER)
    protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<IncidentBackend>,
  ) {
    super(
      ModelTypes.Incident,
      new IncidentTranslator(),
      datastore,
      null,
      defaultSelectors,
      defaultDispatchers,
      createIncidentThunk,
      updateIncidentThunk,
      deleteIncidentThunk,
      loadIncidentThunk,
    );
  }
}
